import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";
import Main from "./components/main";
import "./style.css";

ReactDOM.render(<Main />, document.getElementById("root"));
